export const PULL_REQUESTS_PANEL_KEY = "workspace:pull-requests";

export function pullRequestsPanelKey(): string {
  return PULL_REQUESTS_PANEL_KEY;
}
